import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconNames } from '@icon/assets';
import { UIIconComponent, UiNumberComponent } from '@design-system';
import { MarketSymbol } from '../symbol.model';
import { SymbolSparklineComponent } from '../symbol-sparkline/symbol-sparkline.component';

@Component({
	selector: 'app-symbol-card',
	imports: [UiNumberComponent, UIIconComponent, SymbolSparklineComponent, RouterLink],
	templateUrl: './symbol-card.component.html'
})
export class SymbolCardComponent {
	readonly item = input.required<MarketSymbol>();
	readonly pinToggled = output<string>();

	readonly pinIcon = computed<IconNames>(() => (this.item().pinned ? 'pin-fill' : 'pin'));
	readonly isPositiveChange = computed(() => this.item().changePercent >= 0);
	readonly changeClass = computed(() => {
		if (this.item().changePercent === 0) {
			return 'text-gray-900 text-3.25 font-medium';
		}
		return this.isPositiveChange() ? 'text-green-500 text-3.25 font-medium' : 'text-red-500 text-3.25 font-medium';
	});
	readonly formattedChange = computed(() => {
		const value = this.item().changePercent;
		return `(${value}%)`;
	});

	/**
	 * The pin sits outside the card's link (see the template), so opening the
	 * symbol board is not something this has to suppress — it only reports the
	 * tap. The parent applies it straight away, without a confirmation.
	 */
	onPinClick(): void {
		this.pinToggled.emit(this.item().id);
	}
}
